<template lang="html">
  <div class="inner-modal">
		<div class="head-modal spaced-row">
			<div>
				<div class="head-modal-title">
					Ajouter/Editer un cabinet
				</div>
				<div class="head-modal-emphase">
					Modifiez les informations d’un cabinet ou ajoutez en un.
				</div>
			</div>
			<div class="row">
				<div class="head-modal-label">ACTIVATION</div>
				<toggle-input :value="cabinet.available" @change="cabinet.available = !cabinet.available" />
			</div>
		</div>
		<div class="body-modal">
			<form class="form-ui column default-form-ui">
				<div class="ctn-duo-input row">
					<div class="left inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('name')}">
							<label for="name">Nom du cabinet</label>
							<input v-validate="'required|alpha'" type="text" name="name" v-model="cabinet.name">
						</div>
						<div v-if="errors.has('name')" class="error-message">{{ errors.first('name') }}</div>
					</div>
					<div class="right inner-duo">
						<div class="ctn-input form-elem-container ctn-select ctn-label" v-inputUI :class="{error: errors.has('admin')}">
							<label for="select">Admin</label>
							<v-select 
								v-model="cabinet.admin" 
								:options="adminOptions" 
								v-validate="'required'" 
								data-vv-value-path="mutableValue" 
    							data-vv-name="admin" 
    							:has-error="errors.has('admin')" 
							/>
						</div>
						<div v-if="errors.has('admin')" class="error-message">{{ errors.first('admin') }}</div>
					</div>
				</div>
				<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('cabinetId')}">
					<label for="cabinetId">ID</label>
					<input v-validate="'required|alpha'" type="text" name="cabinetId" v-model="cabinet.cabinetId">
				</div>
				<div v-if="errors.has('cabinetId')" class="error-message">{{ errors.first('cabinetId') }}</div>
				<div class="ctn-cta right row">
					<div class="btn btn-gold" @click="close">Annuler</div>
					<div class="btn btn-red" @click="validateBeforeSubmit">Enregistrer</div>
				</div>
			</form>
		</div>
  </div>
</template>

<script>

const DEFAULT_CABINET = {
	name: null,
	cabinetId: null,
	admin: null,
	advisors: [],
	clients: [],
	available: true
}
export default {
	name: 'AddCabinet',
	props: ['data'],
	data () {
		return {
			adminOptions: [],
			cabinet: DEFAULT_CABINET
		}
	},
	beforeMount () {
		this.$store.dispatch('getConseillers')
		.then(() => {
			this.adminOptions = this.$store.getters['conseillers']
							.filter(conseiller => conseiller.role === "Admin")
							.map(conseiller => conseiller.name)
		})
		if (this.data) {
			this.cabinet = this.data
		} else {
			this.cabinet = {...DEFAULT_CABINET}
		}
	},
	methods: {
		close () {
			this.$emit('close')
		},
		submit () {
			this.$store.dispatch('addCabinet', this.cabinet)
			.then(() => {
				this.close()
				this.cabinet = DEFAULT_CABINET
			})
		},
		validateBeforeSubmit () {
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.submit()
					return
				}
			});
		}
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// CabinetModal.vue?b0a4c23c